/**
* @toBeChange
* Muss je Projekt angepasst werden. Imports können in Standardprodukten rausgelöscht werden. Genauso wie die ##REPLACEELEMENT##. 
* Ist nur relevant, wenn eine Buildlogik eingebaut wird, die einzelne Abschnitte verwendet.
* import { URL_PARAMS, ROUTESURL } from 'src/app/app-routing.model';
* import { canActivate } from 'src/app/shared/services/authorization/auth.utils.service';
* import { startModule } from 'src/app/base/services/start-module.service';
**/


export const routesH = [
   
]